export default __webpack_public_path__ + "static/band-logo-tv-3-e8ba4668b6bf044e629ee89bbbb9bc9b.png";